export const backend_routes = {
    AUTH_LINK : "/go/auth/login",
    REFRESH_TOKENS_LINK : "/go/auth/refresh",

    FORECASTS_YEAR_POST : "/go/forecast/year",
    FORECASTS_MONTH_POST : "/go/forecast/month",
    FORECASTS_DAY_POST : "/go/forecast/day",
    FORECASTS_BASE_POST : "/go/forecast/",
    FORECASTS_BASE_PATCH : "/go/forecast/",

    FORECASTS_DAYS_AND_MONTH : "/go/forecast/month/01.",

    FORECASTS_ALL_YEARS : "/go/forecast/allYears",
    FORECASTS_ALL_MONTHS_BY_YEAR : "/go/forecast/allMonths/",
    FORECASTS_AVAILABLE_YEARS_LINK : "/go/forecast/filledYears",
    FORECASTS_AVAILABLE_MONTHS_LINK : "/go/forecast/filledMonths",

    FORECASTS_DELETE_LINK : "/go/forecast/",

    EVENTS_LIST : "/go/forecast/event/list",
    EVENTS_UPDATING : "/go/forecast/event/update",
    EVENTS_POST: "/go/forecast/event/add",
    EVENTS_DELETE: "/go/forecast/event/",
    LEGENDS_LIST : "/go/astro/config/legend/list",
    LEGENDS_UPDATING : "/go/forecast/legend/update",
    LEGENDS_POST : "/go/forecast/legend/add"
}

export const appPages = [
    { state: "forecasts_year", text: "Прогнозы на год" },
    { state: "forecasts_month", text: "Месячные прогнозы" },
    { state: "forecasts_day", text: "Дневные прогнозы" },
    // { state: "forecasts", text: "Прогнозы" },
    { state: "events", text: "События" },
]

export const devMode = false;
// export const baseUrl = "http://192.168.0.4:8000";
// export const baseUrl = "http://localhost:8000";
export const baseUrl = "https://astro-planner.ru";
export const monthNames = {
    "01": "Январь",
    "02": "Февраль",
    "03": "Март",
    "04": "Апрель",
    "05": "Май",
    "06": "Июнь",
    "07": "Июль",
    "08": "Август",
    "09": "Сентябрь",
    "10": "Октябрь",
    "11": "Ноябрь",
    "12": "Декабрь",
}